import { cn } from "@/lib/utils";

type ChatBubbleProps = {
    title?: React.ReactNode;
    children: React.ReactNode;
    header?: React.ReactNode;
    alignLeft?: boolean;
    alignRight?: boolean;
    variant?: "default" | "image";
};


const ChatBubble: React.FC<ChatBubbleProps> = ({ title, header, children, alignRight, alignLeft, variant = 'default' }) => {

    return (
        <div className={cn(
            "ChatBubble | flex flex-col items-start",
            {
                "items-end": alignRight,
            })}>
            {title && (
                <div
                    className={cn(
                        "font-frutigerRoman font-bold uppercase italic text-[8px]",
                        "2xs:text-xs 2xs:mb-1",
                        "drop-shadow-[0_0px_7px_rgba(0,0,0,0.5)]",
                        "4k:text-[48px]",
                        {
                            "pl-4 4k:pl-[64px]": alignLeft,
                            "pr-4 4k:pr-[64px]": alignRight,
                        }
                    )}
                >
                    {title}
                </div>
            )}
            <div className={cn(
                "font-frutigerRoman text-xs",
                "rounded-[10px] 2xs:rounded-[14px]",
                "backdrop-blur-md shadow-[inset_-0.67px_0.67px_0.67px_0_rgba(255,255,255,0.35),inset_0px_0.67px_5.33px_0_rgba(255,255,255,0.35)]",
                "bg-whiteShade-2",
                "text-shadow-chat-button",
                "4k:text-[52px] 4k:leading-[120%]",
                {
                    "max-w-[230px] 2xs:max-w-[311px] 4k:max-w-[1388px] inline-flex": alignLeft || alignRight,
                    "max-w-[230px] 2xs:max-w-[360px] 4k:max-w-[1388px] md:max-w-[490px]": variant === 'image',
                    "rounded-tl-[2px] 2xs:rounded-tl-[3px] 4k:rounded-tl-[8px]": title && alignLeft,
                    "rounded-br-[2px] 2xs:rounded-br-[3px] 4k:rounded-br-[8px]": title && alignRight,
                    "pt-12 flex-col 4k:pt-[192px]": header
                }
            )}>
                {header && (
                    <div className="w-full relative -mt-12 4k:-mt-[192px] py-[6px] 4k:py-[24px] px-4 4k:px-[64px] bg-blackShade-15">{header}</div>
                )}
                <div className={cn("px-4 4k:px-[64px] py-3 4k:py-[48px]", {
                    "px-[6px] 4k:px-[24px] py-[6px] 4k:py-[24px] 2xs:py-3 2xs:px-3": variant === 'image',
                })}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ChatBubble;


